export default __webpack_public_path__ + "static/media/track-elements-location-off.1636b2ce.svg";